"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsAndStandingsStencil = exports.resultsAndStandingsStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.resultsAndStandingsStencilDefinition = {
    view: {
        label: 'Results and Standings',
        group: 'Misc.',
        titleItems: ['title'],
        imageItems: [],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'title',
                    'results-table',
                    'results-table-additional',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'event-profile',
                            'event-season',
                            'featured-media',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: ['disciplines', 'content-categories'],
            },
        ],
    },
    content: {
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: {
            ...properties_1.disciplinesPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: ['discipline'],
                },
            ],
        },
        [properties_1.eventProfilePropertyDefinition.name]: properties_1.eventProfilePropertyDefinition,
        [properties_1.eventSeasonPropertyDefinition.name]: properties_1.eventSeasonPropertyDefinition,
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.resultsTablePropertyDefinition.name]: properties_1.resultsTablePropertyDefinition,
        [properties_1.resultsTableAdditionalPropertyDefinition.name]: properties_1.resultsTableAdditionalPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: {
            ...properties_1.titlePropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'maxLength',
                    argument: 50,
                },
            ],
        },
    },
    localizations: [],
    roles: [],
    spaces: [
        'alinghi',
        'batalla',
        'brand-building-events',
        'erc',
        'global',
        'organics',
        'organics-mixed-consumption',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'redbull-advancedtechnologies',
        'redbull-f1academy',
        'redbull-racing',
        'redbull-powertrains',
        'redbull-simracing',
        'redbull_com',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
        'wrc',
        'xalps',
    ],
    name: 'results-and-standings',
};
const isResultsAndStandingsStencil = (stencil) => {
    return stencil.name === exports.resultsAndStandingsStencilDefinition.name;
};
exports.isResultsAndStandingsStencil = isResultsAndStandingsStencil;
//# sourceMappingURL=data:application/json;base64,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